export const PURCHASE_DOC_TYPES = {
  ORDER: 2,
  INVOICE: 1,
  DELIVERY_NOTE: 3,
};
